import AnalyticsService from '@root/core/src/services/analytics-service';
import NevermindLink from '@root/core/src/components/nevermind-link';
import ProfileDisclaimer from '@root/profile/src/components/profile-disclaimer';
import ProfileForm from '@root/profile/src/components/profile-form';
import ProfileHeading from '@root/profile/src/components/profile-heading';
import ProfileModalButton from '@root/profile/src/components/profile-modal-button';
import PropTypes from '@root/vendor/prop-types';
import RadioOption from '@root/core/src/components/radio-option';
import React, { Component } from '@root/vendor/react';
import SubHeading from '@root/profile/src/components/sub-heading';
import VehicleCreationParams from '@root/auto-pricing/src/models/vehicle-creation-params';

export default class ProfileAddVehicleAntiTheft extends Component {
  static propTypes = {
    brandedColor: PropTypes.string,
    brandInfoColor: PropTypes.string,
    cssButtonOverrides: PropTypes.object,
    disableCancel: PropTypes.bool,
    linkStyles: PropTypes.object,
    module: PropTypes.arrayOf(PropTypes.string).isRequired,
    onCancel: PropTypes.func.isRequired,
    onDone: PropTypes.func.isRequired,
    vehicleCreationParams: PropTypes.instanceOf(VehicleCreationParams).isRequired,
    vin: PropTypes.string,
  };

  static analyticsContext = 'PROFILE_ADD_VEHICLE_ANTI_THEFT';

  state = {
    antiTheftEquipment: null,
  };

  componentDidMount() {
    AnalyticsService.trackViewEvent(this._getAnalyticsContext());
  }

  _getAnalyticsContext = () => [...this.props.module, ProfileAddVehicleAntiTheft.analyticsContext];

  _handleSelectYes = () => {
    this.setState({
      antiTheftEquipment: true,
    });
  }

  _handleSelectNo = () => {
    this.setState({
      antiTheftEquipment: false,
    });
  }

  _handleCancel = () => {
    AnalyticsService.trackClickEvent(this._getAnalyticsContext(), 'CANCEL');
    this.props.onCancel();
  }

  _handleSubmit = () => {
    AnalyticsService.trackClickEvent(this._getAnalyticsContext(), 'CONTINUE');
    if (this.state.antiTheftEquipment !== null) {
      const vehicleCreationParams = this.props.vehicleCreationParams.set('antiTheftEquipment', this.state.antiTheftEquipment);
      this.props.onDone(vehicleCreationParams);
    }
  }

  render() {
    return (
      <div>
        <ProfileHeading>
          Does this vehicle have anti-theft equipment?
        </ProfileHeading>
        {this.props.vin && (
          <SubHeading>
            VIN: {this.props.vin}
          </SubHeading>
        )}
        <ProfileForm onSubmit={this._handleSubmit}>
          <RadioOption
            circleColor={this.props.brandInfoColor}
            id={'anti-theft-yes'}
            isSelected={!!this.state.antiTheftEquipment}
            label={'Yes'}
            name={'anti-theft'}
            onChange={this._handleSelectYes}
            optionValue={'Y'}
          />
          <RadioOption
            circleColor={this.props.brandInfoColor}
            id={'anti-theft-no'}
            isSelected={this.state.antiTheftEquipment === false}
            label={'No'}
            name={'anti-theft'}
            onChange={this._handleSelectNo}
            optionValue={'N'}
          />
          <ProfileModalButton
            cssButtonOverrides={this.props.cssButtonOverrides}
            disabled={this.state.antiTheftEquipment === null}
          >
            Continue
          </ProfileModalButton>
          {!this.props.disableCancel && (
            <NevermindLink
              linkStyles={this.props.linkStyles}
              onCancel={this._handleCancel}
            />
          )}
        </ProfileForm>
        <ProfileDisclaimer
          text={'We’re looking for any system or device that is designed to prevent theft and is permanently installed on your vehicle.'}
        />
      </div>
    );
  }
}
